export default __webpack_public_path__ + "static/media/Shemite Exile Wristguards.bdce6c14.jpg";